module.exports = "/assets/data/5a4016de5eaae3a67a9af37fbe846c6f-LU6.data.json";